module.exports = __webpack_public_path__ + "static/media/ChangeLangFrEn.bf18bc01.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ChangeLangFrEn.png
// module id = 617
// module chunks = 0